var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{attrs:{"filterable":"","props":_vm.props,"show-all-levels":false},model:{value:(_vm.selectedArr),callback:function ($$v) {_vm.selectedArr=$$v},expression:"selectedArr"}})}
var staticRenderFns = []

export { render, staticRenderFns }